<template>
    <div>
        <NavigationReceiver currentQuestion="12"></NavigationReceiver>
        <section class="pt-5">
            <div class="custom-container">
                <div class="row">
                    <div class="col-xl-3">
                        <div class="alert alert-warning d-flex mb-2" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Kijk niet langer dan een week terug en vul dan de vragen zo goed mogelijk in.</span>
                        </div>
                        <div class="alert alert-warning d-flex mb-5" role="alert">
                            <i class="fi fi-rr-bell-ring me-2"></i>
                            <span>Activiteiten die u wél als zwaar ervaart en die niet in de lijst staan, kunt u aan het eind toevoegen.</span>
                        </div>
                    </div>
                    <div class="col-xl-6 px-5">
                        <div class="row justify-content-center mb-4">
                            <div class="col-xl-3 col-4">
                                <img src="/img/questions/vraag11.png" class="img-fluid">
                            </div>
                        </div>
                        <h2 class="mb-4 text-center">{{ QuestionRepository.getQuestionValueById(12.1) }}</h2>
                        <div class="row justify-content-center">
                            <div class="col-lg-12 col-12">
                                <RadioField :error="error" :options="[{
                                        value: 'ja',
                                        title: 'Ja'
                                    }, {
                                        value: 'nee',
                                        title: 'Nee'
                                    }]" id="12.1"></RadioField>
                                <transition name="fade-in-up">
                                    <div v-if="showFields()">
                                        <TextareaField :placeholder="QuestionRepository.getQuestionValueById(12.2)" id="12.2" :title="QuestionRepository.getQuestionValueById(12.2)"></TextareaField>
                                        <span class="sub">{{ QuestionRepository.getQuestionValueById(12.3) }}</span>
                                        <NumberField id="12.3" placeholder="... uur per dienst" title="... uur per dienst"></NumberField>
                                    </div>
                                </transition>
                                <div class="text-center">
                                    <button @click="nextStep($event)" class="btn btn-primary mb-3">Volgende vraag</button>
                                    <br>
                                    <button class="btn-previous-question" @click="previousStep($event)">Vorige vraag</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
import NavigationReceiver from "../../../defaults/Navigation-receiver";
import RadioField from "../../../includes/RadioField";
import TextareaField from "../../../includes/TextareaField";
import SelectField from "../../../includes/SelectField";
import NumberField from "../../../includes/NumberField";
import defaultData from "./defaultData";
import RecipientService from "../../../../services/RecipientService";
import defaultMethods from "./defaultMethods";

export default {
    name:       'StepTwelve',
    components: { NumberField, SelectField, TextareaField, RadioField, NavigationReceiver },
    data() {
        return {
            ... defaultData,
            showFieldsOn:     '12.1',
            nextStepSlug:     'stap-13',
            previousStepSlug: 'stap-11',
            error:            false
        }
    },
    beforeRouteEnter(to, from, next) {
        RecipientService.getPrerequisites(to, from, next, true);
    },
    methods: {
        ... defaultMethods
    }
}
</script>
